export default __webpack_public_path__ + "static/media/home-page-short-background.91cff91b.png";